import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'components/ui/tooltip';
import { Icon } from 'components/ui/icon';

interface IProps {
  id: string;
  className?: string;
}

const CopyIDToClipboard = ({ id, className }: IProps): JSX.Element => {
  const [copied, setCopied] = useState(false);
  const setCopiedWithTooltip = (state: boolean) => {
    setCopied(state);
  };

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
  }, [copied]);

  return (
    <div
      className={classNames(
        'text-xs leading-4 font-normal text-gray-blue-50 mb-2',
        'flex items-center',
        className
      )}
    >
      <div className="pb-1 pt-1">{id}</div>
      <TooltipProvider>
        <Tooltip open={copied}>
          <TooltipTrigger asChild>
            <span
              data-testid="clipboard"
              onClick={() => {
                setCopiedWithTooltip(true);
              }}
              className="pl-1"
            >
              <CopyToClipboard text={id || 'NA'}>
                <Icon
                  name="copy"
                  size={20}
                  className={classNames(
                    'p-1 hover:bg-gray-blue-3 hover:rounded-sm hover:cursor-pointer',
                    'ml-2 inline align-middle'
                  )}
                />
              </CopyToClipboard>
            </span>
          </TooltipTrigger>
          <TooltipContent side="bottom">Copied!</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default CopyIDToClipboard;
